// extracted by mini-css-extract-plugin
export default {"title":"ActivitiesStaffTab_title__DUTCG","headerLeftTitleWrap":"ActivitiesStaffTab_headerLeftTitleWrap__6+0Yi"};